"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseShapeDiverSdk = void 0;
const ShapeDiverSdkApi_1 = require("./api/ShapeDiverSdkApi");
const ShapeDiverSdkConfig_1 = require("./config/ShapeDiverSdkConfig");
class BaseShapeDiverSdk {
    constructor(baseUrl) {
        this.sdkConfig = new ShapeDiverSdkConfig_1.SdkConfigInternal(baseUrl);
        this.sdkApi = new ShapeDiverSdkApi_1.ShapeDiverSdkApi(this.sdkConfig);
    }
    setConfigurationValue(type, value) {
        this.sdkConfig.setConfigValue(type, value);
    }
    get configuration() {
        return this.sdkConfig.toConfig();
    }
}
exports.BaseShapeDiverSdk = BaseShapeDiverSdk;
//# sourceMappingURL=BaseShapeDiverSdk.js.map